import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M8.75 0A7.25 7.25 0 0 1 16 7.25c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75A5.75 5.75 0 0 0 8.75 1.5.75.75 0 0 1 8 .75c0-.416.334-.75.75-.75M9 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2M8 3.75c0-.416.334-.75.75-.75A4.25 4.25 0 0 1 13 7.25c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75A2.75 2.75 0 0 0 8.75 4.5.75.75 0 0 1 8 3.75m2.281 5.21a1.245 1.245 0 0 1 1.46-.357l3.5 1.5c.55.235.856.828.73 1.41l-.75 3.5A1.25 1.25 0 0 1 14 16a11 11 0 0 1-.569-.012h-.003a13 13 0 0 1-.925-.07C5.475 15.176 0 9.226 0 2 0 1.41.413.9.988.778l3.5-.75A1.25 1.25 0 0 1 5.897.76l1.5 3.5a1.25 1.25 0 0 1-.356 1.46L5.77 6.756a9.6 9.6 0 0 0 3.473 3.472zm4.182 2.44-3.138-1.344-.919 1.119a1.5 1.5 0 0 1-1.912.347 11.06 11.06 0 0 1-4.019-4.019 1.5 1.5 0 0 1 .347-1.912l1.122-.92L4.6 1.535l-3.097.67C1.61 8.943 7.056 14.39 13.797 14.5z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0h16v16H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }